var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BrowserBreadcrumbTypes, EventTypes, PageLifeType, StoreType } from '@heimdallr-sdk/types';
import { formatDate, generateUUID, getCookie, getStore, getDeepPropByDot } from '@heimdallr-sdk/utils';
function getStoreUserId(userIdentify) {
    var _a = userIdentify.name, name = _a === void 0 ? '' : _a, _b = userIdentify.postion, postion = _b === void 0 ? '' : _b;
    switch (postion) {
        case StoreType.LOCAL:
        case StoreType.SESSION:
            return getStore(postion, name);
        case StoreType.COOKIE:
            return getCookie(name);
        case StoreType.GLOBAL:
            return getDeepPropByDot(name, window);
        default:
            break;
    }
    return '';
}
var LifeCyclePlugin = {
    name: 'lifeCyclePlugin',
    monitor: function (notify) {
        var _this = this;
        var _a = this.getOptions().userIdentify, userIdentify = _a === void 0 ? {} : _a;
        var userPath = userIdentify.name, userPosi = userIdentify.postion;
        this.sessionID = generateUUID();
        window.addEventListener('load', function () {
            var user_id = getStoreUserId(userIdentify) || '';
            if (userPath && userPosi && !user_id) {
                _this.log("".concat(userPath, " does not exist on ").concat(userPosi));
            }
            notify({
                type: PageLifeType.LOAD,
                session_id: _this.sessionID,
                user_id: user_id,
                href: location.href
            });
        });
        window.addEventListener('unload', function () {
            var user_id = getStoreUserId(userIdentify) || '';
            if (userPath && userPosi && !user_id) {
                _this.log("".concat(userPath, " does not exist on ").concat(userPosi));
            }
            notify({
                type: PageLifeType.UNLOAD,
                session_id: _this.sessionID,
                user_id: user_id,
                href: location.href
            });
        });
    },
    transform: function (collectedData) {
        var id = generateUUID();
        var type = collectedData.type, href = collectedData.href;
        var action = '';
        switch (type) {
            case PageLifeType.LOAD:
                action = 'Enter';
                break;
            case PageLifeType.UNLOAD:
                action = 'Leave';
                break;
            default:
                break;
        }
        this.breadcrumb.unshift({
            eventId: id,
            type: BrowserBreadcrumbTypes.LIFECYCLE,
            message: "".concat(action || type, " \"").concat(href, "\"")
        });
        var subType = type;
        delete collectedData.type;
        return {
            id: id,
            time: formatDate(),
            type: EventTypes.LIFECYCLE,
            data: __assign({ sub_type: subType }, collectedData)
        };
    }
};
export default LifeCyclePlugin;
